import store from '../store';
import OutboundPostMessageService from '../services/OutboundPostMessageService';
import { isIos } from './BrowserHelpers';

/**
 * A RemoteParticipant muted or unmuted its media.
 * @param {Room} room - The Room you have joined
 * @param {function} onMutedMedia - Called when a RemoteParticipant muted its media
 * @param {function} onUnmutedMedia - Called when a RemoteParticipant unmuted its media
 * @returns {void}
 */
export function participantMutedOrUnmutedMedia(room, onMutedMedia, onUnmutedMedia) {
  room.on('trackSubscribed', (track, publication, participant) => {
    track.on('disabled', () => onMutedMedia(track, participant));
    track.on('enabled', () => onUnmutedMedia(track, participant));
  });
}

// plays sounds from rhinonative when on a call to prevent interrupting audio
export function checkActiveVideoIos(id) {
  const { nativeApp, rhinovideo } = store.getState();
  const onVideoCallRhinonativeIos = nativeApp.isNativeApp && isIos() && rhinovideo.currentVideoId;
  if (onVideoCallRhinonativeIos) {
    OutboundPostMessageService.postMessage({
      type: 'playSound',
      data: {
        soundName: id,
      },
    });
  }
  return onVideoCallRhinonativeIos;
}
